import { Skeleton, Stack } from "@skailer-com/uikit";

export function TimeOffRequestSkeleton() {
  return (
    <Stack gap="md">
      <Stack direction={"vertical"} gap={"md"}>
        <Skeleton className={"w-41 h-41 rounded-sm"}></Skeleton>
        <Stack gap="xs">
          <Skeleton className={"w-40 h-8 rounded-sm"}></Skeleton>
          <Skeleton className={"w-28 h-6 rounded-sm"}></Skeleton>
        </Stack>
      </Stack>
      <Skeleton className={"w-32 h-5 rounded-sm"}></Skeleton>
      {new Array(6).fill(0).map((_, i) => (
        <Stack gap={"sm"} className={"border-b border-dark/10 py-2"} key={`timeoff-skeleton-${i}`}>
          <Skeleton className={"w-40 h-4 rounded-sm"}></Skeleton>
          <Skeleton className={"w-28 h-4 rounded-sm"}></Skeleton>
        </Stack>
      ))}
      <Skeleton className={"w-32 h-5 rounded-sm mt-6 mb-2"}></Skeleton>
      <Stack direction={"horizontal"} gap={"md"} items={"center"}>
        <Skeleton className={"w-8 h-8 rounded-sm"}></Skeleton>
        <Stack gap="xs">
          <Skeleton className={"w-40 h-4 rounded-sm"}></Skeleton>
          <Skeleton className={"w-28 h-3 rounded-sm"}></Skeleton>
        </Stack>
      </Stack>
    </Stack>
  );
}
